import { useState } from 'react';
import { useIntl } from 'react-intl';
import ReactTooltip from 'react-tooltip';

import LucideIcon from 'src/componentes/lucide-icon';
import Input from 'src/componentes/input';
import Checkbox from 'src/componentes/checkbox';
import InputNumber from 'src/componentes/input-number';
import ColaboradorEGrupoEResponsabilidadeLookup from 'src/lookups/ColaboradorEGrupoEResponsabilidadeLookup';
import guid from 'src/utils/guid';
import GrauRiscoLookup from 'src/lookups/grau-risco';

const Edit = ({
  model,
  index,
  etapa,
  provided,
  showTrashIcon,
  disabled,
  ehFluxoNegociacaoMetas,
  ehAvaliacaoRisco = false,
  ehGestaoDocumento = false,
  ehStageGate = false,
}) => {
  const intl = useIntl();

  const [tooltipId] = useState(`UNIQUE-APPV-${guid()}`);

  const handleChangeFields = (field, value) => {
    const newList = [...model.value];
    const item = newList[index];

    if (item) item[field] = value;

    model.requestChange(newList);
  };

  const handleChangePeopleAndGroupsAndResponsibilities = (list) => {
    const newApprovers =
      list?.filter((x) => x.identificadorLista === 'colaboradores') || [];
    const newGroups =
      list?.filter((x) => x.identificadorLista === 'grupos') || [];
    const newResponsibilities =
      list?.filter((x) => x.identificadorLista === 'responsabilidades') || [];

    handleChangeFields('aprovadores', newApprovers);
    handleChangeFields('gruposAprovadores', newGroups);
    handleChangeFields('responsabilidades', newResponsibilities);
  };

  const handleRemove = () => {
    const newList = [...model.value];
    newList.splice(index, 1);

    model.requestChange(newList);
  };

  const aprovadores = etapa.aprovadores || [];
  const gruposAprovadores = etapa.gruposAprovadores || [];
  const responsabilidades = etapa.responsabilidades || [];
  const grausRisco = etapa.grausRisco || [];
  const duracao = etapa.duracao || null;

  return (
    <tr
      ref={provided.innerRef}
      {...provided.draggableProps}
      style={{
        ...provided.draggableProps.style,
      }}
    >
      {!disabled && (
        <td
          style={{ width: '5%' }}
          className="text-center pt-1"
          {...provided.dragHandleProps}
        >
          <LucideIcon size={22} icon="drag" />
        </td>
      )}
      <td
        style={{
          width: '20%',
        }}
        className="pr-3 pt-1"
      >
        <Input
          autoFocus={false}
          formStyle={{ marginBottom: 0 }}
          disabled={disabled}
          model={{
            label: '',
            value: etapa.nome,
            requestChange: (v) => handleChangeFields('nome', v),
          }}
          required
        />
      </td>
      <td
        style={{ width: ehAvaliacaoRisco ? '45%' : '60%' }}
        className="pr-3 pt-1"
      >
        <ColaboradorEGrupoEResponsabilidadeLookup
          multi
          autoFocus={false}
          formGroupStyle={{ marginBottom: 0 }}
          disabled={disabled}
          ehFluxoNegociacaoMetas={ehFluxoNegociacaoMetas}
          ehAvaliacaoRisco={ehAvaliacaoRisco}
          ehGestaoDocumento={ehGestaoDocumento}
          ehStageGate={ehStageGate}
          model={{
            label: '',
            value: [...aprovadores, ...gruposAprovadores, ...responsabilidades],
            requestChange: handleChangePeopleAndGroupsAndResponsibilities,
          }}
          data={{ ehFluxoNegociacaoMetas: ehFluxoNegociacaoMetas }}
        />
      </td>
      {ehAvaliacaoRisco && (
        <td style={{ width: '25%' }} className="pr-3 pt-1">
          <GrauRiscoLookup
            className="pt-3"
            multi
            model={{
              label: '',
              value: grausRisco,
              requestChange: (v) => handleChangeFields('grausRisco', v),
            }}
          />
        </td>
      )}
      {ehGestaoDocumento && (
        <td style={{ width: '10%' }} className="pr-3 pt-1">
          <InputNumber
            formStyle={{ marginBottom: 0 }}
            model={{
              label: '',
              value: duracao,
              requestChange: (v) => handleChangeFields('duracao', v),
            }}
          />
        </td>
      )}
      <td style={{ width: '15%' }} className="pr-3 pt-1">
        <div className="d-flex align-items-center font-weight-bold">
          <Checkbox
            autoFocus={false}
            disabled={disabled}
            model={{
              label: intl.formatMessage({ id: 'aprovacaoUnica' }),
              value: etapa.aprovacaoUnica,
              requestChange: (v) => handleChangeFields('aprovacaoUnica', v),
            }}
          />
          <LucideIcon
            id={tooltipId}
            data-for={tooltipId}
            data-tip
            size={14}
            className="ml-2 text-muted"
            icon="information-outline"
          />
        </div>
        <ReactTooltip
          className="fluxo-aprovacao-tooltip"
          id={tooltipId}
          aria-haspopup="true"
        >
          {intl.formatMessage({ id: 'aprovacaoUnicaExplicacao' })}
        </ReactTooltip>
      </td>
      {showTrashIcon && !disabled && (
        <td style={{ width: '5%' }} className="text-center text-primary pt-1">
          <LucideIcon
            size={20}
            onClick={handleRemove}
            className="cursor-pointer"
            icon="delete"
          />
        </td>
      )}
    </tr>
  );
};

export default Edit;
